<template>
  <div id="app">
    <v-app>
      <v-app-bar v-if="user != null && !hideAppBar" class="pb-4 pt-4 px-6 px-lg-14 appbar">
        <div class="mx-0 row justify-content-between align-items-center flex py-4">
            <div class="p-0 col-2 applogocontainer">
              <img class="applogo justify-content-start" src="../assets/img/svg/muniman-Logo-black.png" alt="">
            </div>
            <div class="p-0 col-9 mx-0 row justify-content-center align-items-center h-100">
              <v-btn class="appbarbtn" v-if="user != null" :ripple="false" @click="navObject = null" text v-for="route in allowedRoutes" :key="route.name" :to="route.to">{{ $t(route.key) }}</v-btn>
              <!-- <v-btn class="appbarbtn" :ripple="false" text >Stammdaten</v-btn>
              <v-btn class="appbarbtn" :ripple="false" text >Benutzer</v-btn>
              <v-btn class="appbarbtn" :ripple="false" text >Rollen</v-btn>
              <v-btn class="appbarbtn" :ripple="false" text >Mandanten</v-btn> -->
            </div>
            <div class="col-1 p-0 row justify-content-end align-items-start align-items-sm-end">
              <v-menu
              v-model="logoutMenu"
              offset-y
              left
              flat>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                  class="mt-2 mt-sm-0"
                  v-bind="attrs"
                  v-on="on"
                  :ripple="false"
                  text
                  fab
                  small>
                    <img width='100%' height='auto' src="../assets/img/svg/icons/user.svg" style="width: 24px;">
                  </v-btn>
                </template>
                <v-card flat class="filtercard rounded-0" color="#161616">
                  <v-list class="pa-0 transparent" >
                    <v-list-item>
                      <v-list-item-title class="white--text">
                        {{user.name == "" ? user.personalData.firstname + " " + user.personalData.lastname : user.name}}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item class="white--text" @click="showingLanguageSelector = true;">
                      {{ $t("select_language") }}
                    </v-list-item>
                    <v-list-item @click="logout()">
                      <v-list-item-title class="white--text">
                        Logout
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </div>

        </div>
      </v-app-bar>
      <v-navigation-drawer
      v-model="drawer"
      stateless
      fixed
      right
      v-bind:class="{'findings-drawer' : navObject.type == 'findings','users-drawer' : navObject.type == 'users','users-drawer' : navObject.type == 'tenants'}"
      class="w-md-75 w-lg-50 w-xs-100"
      v-if="checkDrawer()"
      >
      <div v-if="navObject.type == 'findings'">
        <findings-form :reload="fetchEntries" :close="close" :nav-object="navObject" :edit-entry="editEntry" :metadata="metadata" :get-entry-popup-tabs="getEntryPopupTabs" />
      </div>
      <div v-if="navObject.type == 'users'">
        <users-form :removeDevice="removeDevice" :reload="fetchUsers" :close="close" :nav-object="navObject" :edit-user="editUser" :metadata="metadata" />
      </div>
      <div v-if="navObject.type == 'tenants'">
        <tenants-form :reload="fetchCustomers" :close="close" :nav-object="navObject" :edit-tenant="editTenant" :metadata="metadata" />
      </div>
      </v-navigation-drawer>

      <!-- Navigation -->

      <v-main class="main">
        <router-view  ref="findings" @showTenantForm="showTenantForm"  @pullUserData="pullUserData" @pullData="pullData" @showUserDetails="showUserDetails" @showDetails="showDetails" @updateState="updateState">
        </router-view>
      </v-main>

      <LanguageSelector v-model="showingLanguageSelector" />

    </v-app>
  </div>
</template>

<script>
import Vue from 'vue'
// import FindingsForm from '.../BaseData.vue'
import UsersForm from '../components/custom/UsersForm.vue'
import FindingsForm from '../components/custom/FindingsForm.vue'
import TenantsForm from '../components/custom/TenantsForm.vue'
import LanguageSelector from "@/components/custom/LanguageSelector.vue";
import { hasUserRight, isTenantAdmin, hasValidLicense } from '../permissions.js';

const emptyTranslations = () => ({
  DE: "",
  EN: "",
});
const emptyImages = () => ({
  DE: [],
  EN: [],
});

const emptySource = () => ({
  id: null,
  name: "",
  translations: emptyTranslations(),
});

export default {
  name: "app",
  props: {

  },

  components: {
    LanguageSelector,
        FindingsForm,
        UsersForm,
        TenantsForm
    },

  data() {
    return {

      drawer:null,
      logoURL: 'C:\SpringWorkspace\sensys-muniman\BackendServer\src\main\resources\public\static\img\logo.svg',
      editTenant: null,
      navObject: null,
      editEntry:null,
      editUser:null,
      logoutMenu: false,

      metadata:null,
      selectedEntryPopupTab: null,

      showingLanguageSelector: false,

      standardRoutes: [
        {
          key: "objects",
          icon: "fas fa-bomb",
          to: "/findings",
          right: "WriteEntries",
        },
        {
          key: "masterdata",
          icon: "fas fa-database",
          to: "/masterdata",
          right: "WriteMasterdata",
        },
        {
          key: "users",
          icon: "fas fa-user",
          to: "/users",
          right: "ReadUsers",
        },
        {
          key: "licenses",
          icon: "fas fa-certificate",
          to: "/licenses",
          right: "ManageTenant",
        },
        {
          key: "invoices",
          icon: "fas fa-file-invoice",
          to: "/invoices",
          right: "ManageTenant",
          denyGlobalAccess: true, // Hide from super admins, show only to tenant admins
        },
        {
          key: "roles",
          icon: "fas fa-user-tag",
          to: "/roles",
          right: "GlobalAccess",
        },
        {
          key: "customers",
          icon: "fas fa-user-tie",
          to: "/customers",
          right: "GlobalAccess",
        },
        {
          key: "import",
          icon: "fas fa-file",
          to: "/import",
          right: "GlobalAccess",
        },
      ],
      loginRoute: {
        key: "login",
        icon: "fas fa-user",
        to: "/login",
      },
      logoutRoute: {
        key: "logout",
        icon: "fas fa-sign-out-alt",
      },
      allowedRoutes: [],
      user: null,
      hideAppBar: false,
    };
  },

  watch: {
    '$route': {
      immediate: true,
      handler(to) {
        // Hide app bar on subscription-plans page
        this.hideAppBar = to.path === '/subscription-plans';
      }
    }
  },

  mounted() {
    this.getCurrentUser();
    this.getLanguage();
  },

  computed: {
    mini() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },

  methods: {
    checkDrawer(){
      if(this.navObject == null){
        this.drawer = false;
        return this.drawer;
      }else {
        this.drawer = true;
        return this.drawer;
      }
    },
    fetchEntries(){
      this.$refs.findings.searchEntry();
    },
    fetchUsers(){
      this.$refs.findings.fetchUsers();
    },
    fetchCustomers(){
      if(this.$refs.findings && typeof this.$refs.findings.fetchCustomers === 'function'){
        this.$refs.findings.fetchCustomers();
      }
    },
    removeDevice(userid,device){
      this.$refs.findings.confirmDeviceRemove(userid,device);
    },
    updateState(data) {
      if (data.name === "authentication") {
        // Store login type for navigation guard to use
        const isFirstLogin = data.type === "firstLogin";
        Vue.prototype.$isFirstLogin = isFirstLogin;

        // Fetch user data, then let navigation guard decide where to route
        this.getCurrentUser();
      }
    },
    // showNav() {
    //   return window.location.pathname.includes("login") || window.location.pathname.includes("reset-password");
    // },
    reload(){
      this.$refs.fetchEntries.fetchEntries();
    },
    close(){
      if(this.navObject.type == 'findings'){
        this.$refs.findings.drawerClosed();
      }
      this.navObject = null;
    },
    showUserDetails(user){
      this.editUser = user;
      if(user.createmode){
        this.editUser.user = {
        id: null,
        name: "",
        personalData: {
          firstname: "",
          lastname: "",
          birthdate: "2021-01-12",
        },
        mail: "",
        password: "",
        confirmPassword: "",
        role: null,
        deviceIdentifierContainer: {
          deviceIdentifiers: [],
          maxDevices: 0,
        },
        rights: [],
        customer: null,
      };
      }
      this.navObject = user;
    },
    showDetails(entry){
      this.editEntry = entry
      if(entry.createmode){
        this.editEntry.entry = {
                id: null,
                title: "",
                description: "",
                descriptions: emptyTranslations(),
                titles: emptyTranslations(),
                measurements: {
                    diameter: 0,
                    width: 0,
                    totalLength: 0,
                    totalHeight: 0,
                    lengthOfBody: 0,
                    heightOfBody: 0,
                    totalWeight: 0,
                    fillingWeight: 0,
                },
                additionalInfo: {
                    nation: null,
                    periodOfUse: null,
                    drivingBands: [],
                    explosiveBoosters: [],
                    propellant: null,
                    documents: [],
                    form: null,
                    securityAdvices: [],
                    materials: [],
                    filledWith: [],
                },
                sources: [emptySource()],
                images: emptyImages(),
                rawImages: {},
                previewImage: null,
            };
      }
      this.navObject = entry;
    },
    showTenantForm(payload) {
      if (payload?.tenant) {
        // Editing existing tenant - extract address fields from nested address object
        const tenant = payload.tenant;
        this.editTenant = {
          id: tenant.id,
          name: tenant.name,
          clientType: tenant.clientType || 'Organisation',
          streetAddress: tenant.address?.streetAddress || "",
          zipCode: tenant.address?.zipCode || "",
          city: tenant.address?.city || "",
          country: tenant.address?.country || "Deutschland",
          phoneNumber: tenant.phoneNumber || "",
          vat: tenant.vat || "",
          formOfBusiness: tenant.formOfBusiness || "",
          tenantAdmin: tenant.tenantAdmin || {},
          sendInvitationMail: false,
          address: tenant.address // Keep original address object for reference
        };
      } else {
        // Creating new tenant - set default values
        this.editTenant = {
          name: "",
          clientType: 'Organisation',
          streetAddress: "",
          zipCode: "",
          city: "",
          country: "Deutschland",
          phoneNumber: "",
          vat: "",
          formOfBusiness: "",
          tenantAdmin: {},
          sendInvitationMail: true
        };
      }

      this.navObject = { type: "tenants", createmode: !!payload?.createmode };
    },
    pullUserData(metadata){
      this.metadata = metadata;
    },
    pullData(metadata){
      this.metadata = metadata;
    },
    getEntryPopupTabs() {
        // if (this.filtermode) {
        //     return ["general", "measurements", "additionalInfo"];
        // }
        return ["general", "measurements", "additionalInfo", "sources"];
    },
    getDefaultRoute() {
      if (this.isTenantAdmin()) {
        if (this.hasRight('ManageUsers') || this.hasRight('ManageTenantUsers')) {
          return '/users';
        }
        return '/licenses';
      }
      // Check if user has WriteEntries right before defaulting to /findings
      if (this.hasRight('WriteEntries')) {
        return '/findings';
      }
      // Fallback to users or licenses if user doesn't have WriteEntries
      if (this.hasRight('ManageUsers') || this.hasRight('ManageTenantUsers')) {
        return '/users';
      }
      return '/licenses';
    },
    navigateAfterLoad() {
      let targetPath;
      const intendedRoute = sessionStorage.getItem('intended-route');

      if (intendedRoute) {
        sessionStorage.removeItem('intended-route');
        targetPath = intendedRoute;
      } else if (this.$router.currentRoute.path === '/loading' || this.$router.currentRoute.path === '/login') {
        targetPath = this.getDefaultRoute();
      } else {
        targetPath = this.$router.currentRoute.path;
      }

      // Validate targetPath against permissions to avoid unnecessary redirects/errors
      const route = this.$router.match(targetPath);
      let allowed = true;

      // 1. Check denyTenantAdmin
      if (route.meta.denyTenantAdmin && this.isTenantAdmin()) {
        allowed = false;
      }

      // 2. Check requiresRight
      if (allowed && route.meta.requiresRight) {
        const requiredRights = Array.isArray(route.meta.requiresRight) ? route.meta.requiresRight : [route.meta.requiresRight];
        const hasRight = requiredRights.some(right => this.hasRight(right));
        if (!hasRight) allowed = false;
      }

      // 3. Check requiresLicense
      if (allowed && route.meta.requiresLicense && !this.hasValidLicense()) {
        allowed = false;
      }

      if (!allowed) {
        // If intended target is not allowed, fall back to default
        targetPath = this.getDefaultRoute();

        // If default is also not allowed (e.g. license issue), fall back to licenses
        if (!this.hasValidLicense() && this.$router.match(targetPath).meta.requiresLicense) {
          targetPath = '/licenses';
        }
      }

      this.$router.replace(targetPath).catch(() => {});
      progressIndicator.hidden = true;
    },
    getCurrentUser() {
      progressIndicator.hidden = false;
      return this.$axios
        .get("/api/me")
        .then(this.gotCurrentUser)
        .catch(this.requestFailed);
    },
    gotCurrentUser(response) {
      this.user = response.data;
      Vue.prototype.$user = response.data;
      Vue.prototype.$userLoaded = true;

      // Check if browser language differs from user's stored language and update if needed
      this.syncUserLanguageIfChanged();

      // Fetch license validation status from backend
      this.$axios
        .get("/api/me/has-valid-license")
        .then((licenseResponse) => {
          Vue.prototype.$hasValidLicense = licenseResponse.data.hasValidLicense;

          // Build allowed routes for nav menu after license status is loaded
          this.buildAllowedRoutes();

          // Trigger navigation guard to re-check current route with loaded user data
          // The navigation guard in main.js will handle redirects if needed
          this.navigateAfterLoad();
        })
        .catch((error) => {
          console.error("Failed to fetch license status:", error);
          Vue.prototype.$hasValidLicense = false;

          // Build allowed routes even if license check failed
          this.buildAllowedRoutes();

          // Trigger navigation guard to re-check
          this.navigateAfterLoad();
        });
    },

    buildAllowedRoutes() {
      this.allowedRoutes = [];
      for (let i = 0; i < this.standardRoutes.length; i++) {
        const route = this.standardRoutes[i];

        // Check if route requires a right permission
        if (route.right != null && !this.hasRight(route.right)) {
          continue;
        }

        if (route.denyTenantAdmin && this.isTenantAdmin()) continue;

        // Check if route should be denied to super admins (GlobalAccess)
        if (route.denyGlobalAccess && this.hasRight('GlobalAccess')) continue;

        // Check if route requires a valid license
        if (route.requiresLicense && !this.hasValidLicense()) {
          continue;
        }

        this.allowedRoutes.push(route);
      }
    },
    requestFailed(error) {
      Vue.prototype.$userLoaded = true;
      if (error.response && error.response.status === 401) {
        // Check if the current route requires authentication before redirecting
        // or we are in the loading case
        const isAtLoading = this.$router.currentRoute.path === '/loading';
        if (this.$router.currentRoute.meta.requiresAuth !== false|| isAtLoading) {
          this.$router.push("/login").catch(() => {});
        }
      } else if (error.response) {
        this.$noty.error('<i class="fas fa-minus-circle mr-3"></i>' + this.$t(error.response.data));
      } else {
        console.error(error);
      }
      this.user = null;
      progressIndicator.hidden = true;
    },
    requestEnded() {
      progressIndicator.hidden = true;
    },

    hasRight(right) {
      return hasUserRight(this.user, right);
    },

    hasValidLicense() {
      return hasValidLicense(this.user);
    },

    isTenantAdmin() {
      return isTenantAdmin(this.user);
    },

    logout() {
      this.switchToLoginPage();
      this.logoutMenu = false;
    },
    switchToLoginPage() {
      this.$axios.removeBearer();
      this.user = null;
      this.$router.push("login").catch(() => {});
    },
    nothing() {},

    getLanguage() {
      this.$nextTick(() => {
        this.$i18n.locale = localStorage.getItem('locale');
      })
    },

    /**
     * Sync user's email/invoice language with browser language if it has changed.
     * This runs on login to keep the user's preferred language for communications
     * in sync with their device language.
     */
    syncUserLanguageIfChanged() {
      if (!this.user || !this.user.id) return;

      const browserLang = this.$getBrowserLanguage();
      const userLang = this.user.language || 'de';

      // If browser language differs from stored user language, update it
      if (browserLang !== userLang) {
        this.$axios
          .patch(`/api/users/me/language`, browserLang, {
            headers: { 'Content-Type': 'text/plain' }
          })
          .then((response) => {
            // Update local user object with new language
            this.user.language = browserLang;
            Vue.prototype.$user.language = browserLang;
          })
          .catch((error) => {
            console.error('Failed to sync user language:', error);
            // Non-critical error, don't block the user
          });
      }
    }
  }
};
</script>
